import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=61ddc142&scoped=true&"
import script from "./Mail.vue?vue&type=script&lang=js&"
export * from "./Mail.vue?vue&type=script&lang=js&"
import style0 from "./Mail.vue?vue&type=style&index=0&id=61ddc142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddc142",
  null
  
)

export default component.exports